import React from 'react'
import './InformationDetailPanelSection.styles.scss'

export const InformationDetailPanelSection = ({ header, value, children }) => {
    return (
        <div className="row">
            <div className="licence-details-header-col col-md-4">
                {header}
            </div>
            <div className="licence-details-value-col col-md-5">
                {value}
            </div>
            <div className="licence-details-action-col col-md-3">
                {children}
            </div>
        </div>
    )
}
